import React from 'react';
import PropTypes from 'prop-types';

import { Scrollbars } from 'react-custom-scrollbars';

import { withStyles } from '@material-ui/core/styles';
import RootRef from '@material-ui/core/RootRef';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';

import { Fields } from 'redux-form';

import FiltersFields from 'components/fields/FiltersFields';

const styles = theme => ({
  expansionPanel: {
    overflow: 'hidden',
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    '&:last-child': {
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10,
    },
  },
  expansionPanelDetails: {
    flexWrap: 'wrap',
    padding: '8px 20px 8px 8px',
    backgroundColor: theme.palette.grey[100],
  },
});

const OrdersFilterExpansionDetails = ({
  prefix, expanded, variant, expansionDetailsRef, classes,
}) => (
  <ExpansionPanel
    className={classes.expansionPanel}
    elevation={0}
    expanded={expanded}
  >
    <RootRef
      rootRef={expansionDetailsRef}
    >
      <Scrollbars
        autoHeight
        autoHeightMin={0}
        autoHeightMax={300}
        thumbMinSize={30}
        universal
      >
        <ExpansionPanelDetails
          className={classes.expansionPanelDetails}
        >
          <Fields
            id="Order_Filters"
            names={[
              'Filters.User',
              'Filters.Driver',
              'Filters.Status',
              'Filters.Watcher',
              'Filters.Payer',
              'Filters.Type',
              'Filters.Date of Creation',
              'Filters.Date of Service',
              'Filters.Date of Delivery',
              'Filters.Date of Claim Submission',
              'Filters.Sales',
              'Filters.Referral',
              'Filters.Prescriber',
            ]}
            {...variant === 'schedule' ? {
              colored: ['Filters.Driver'],
            } : {}}
            component={FiltersFields}
            prefix={prefix}
          />
        </ExpansionPanelDetails>
      </Scrollbars>
    </RootRef>
  </ExpansionPanel>
);

OrdersFilterExpansionDetails.propTypes = {
  prefix: PropTypes.node,
  expanded: PropTypes.bool,
  variant: PropTypes.oneOf([
    'workflow',
    'schedule',
    'patient',
  ]).isRequired,
  expansionDetailsRef: PropTypes.func,
  classes: PropTypes.shape({
    expansionPanelDetails: PropTypes.string.isRequired,
  }).isRequired,
};

OrdersFilterExpansionDetails.defaultProps = {
  expanded: false,
  prefix: null,
  expansionDetailsRef: () => {},
};

export default withStyles(styles)(OrdersFilterExpansionDetails);



// WEBPACK FOOTER //
// ./src/components/workflow/OrdersFilter/OrdersFilterExpansionDetails.js